import { object, string, mixed } from "yup";
const StringEnumObjectDto = object({
  displayText: string().required(),
  value: mixed((input) => input)
});
function convertEnumToDisplayText(s) {
  return s.replace(/([A-Z])/g, " $1").trim();
}
const isBrowser = () => typeof window !== "undefined";
function delay(ms) {
  return new Promise((res) => setTimeout(res, ms));
}
function parseAsCurrency(val) {
  return setSignificantDigits(val, 2);
}
function setSignificantDigits(val, digits) {
  if (val === void 0 || val === null) {
    return 0;
  }
  return Number(Number(val).toFixed(digits));
}
function parseNumber(x, defaultValue = NaN) {
  if (typeof x === "number" && !Number.isNaN(x)) {
    return x;
  }
  if (typeof x === "string") {
    const parsedString = x.replace(/[^0-9.-]/gi, "");
    const parsedNumber = parsedString.length === 0 ? defaultValue : Number(parsedString);
    return Number.isNaN(parsedNumber) ? defaultValue : parsedNumber;
  }
  return defaultValue;
}
function compareItems(a, b, whitelist) {
  const mapper = (item) => (whitelist || Object.keys(item)).map(
    (key) => getStringIdentifier(item, key)
  );
  const mappedA = mapper(a);
  const mappedB = mapper(b);
  return mappedA.length === mappedB.length && mappedA.every((value, index) => compareItem(value, mappedB[index]));
}
function getStringIdentifier(item, key) {
  const value = item?.[key];
  let stringValue;
  if (typeof value === "undefined" || value === null) {
    return `${key}:null`;
  }
  if (typeof value === "string") {
    stringValue = value;
  } else if (typeof value === "number") {
    stringValue = value.toString();
  } else if (typeof value === "boolean") {
    stringValue = value.toString();
  } else if (value instanceof Date) {
    stringValue = value.toISOString();
  } else if (Array.isArray(value)) {
    if (!value.length) {
      stringValue = "null";
    } else {
      stringValue = value.map((val, index) => getStringIdentifier(value, index)).join(",");
    }
  } else if (typeof value === "object") {
    try {
      stringValue = JSON.stringify(value);
    } catch (err) {
      console.error(err);
      console.log("key", key);
      console.log("value", value);
      stringValue = "null";
    }
  } else {
    throw new Error(`Unsupported type ${value}`);
  }
  return `${key}:${stringValue}`;
}
function compareItem(a, b) {
  if (Array.isArray(a) || Array.isArray(b)) {
    if (Array.isArray(a) && !a.length && (!b || Array.isArray(b) && !b.length) || Array.isArray(b) && !b.length && (!a || Array.isArray(a) && !a.length)) {
      return true;
    }
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((value, index) => compareItem(value, b[index]));
  }
  if (typeof a === "object") {
    return typeof b === "object" && compareItem(
      Object.keys(a).map((key) => key + a[key]),
      Object.keys(b).map((key) => key + b[key])
    );
  }
  if (typeof a === "undefined" || a === null) {
    return typeof b === "undefined" || b === null;
  }
  return a === b;
}
function randomUUID() {
  if ((window ?? globalThis)?.crypto?.randomUUID) {
    return (window ?? globalThis)?.crypto?.randomUUID();
  }
  return `0000${(Math.random() * Math.pow(36, 4) << 0).toString(36)}`.slice(
    -4
  );
}
function waitForCondition(fn, options = {}) {
  const startTime = Date.now();
  const timeout = options.timeout || 15e3;
  const interval = options.timerInterval || 100;
  return new Promise((resolve, reject) => {
    const checkCondition = async () => {
      try {
        const result = await fn();
        if (result) {
          return resolve(true);
        }
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= timeout) {
          return reject(new Error(`Operation timed out after ${timeout}ms`));
        }
        setTimeout(checkCondition, interval);
      } catch (error) {
        reject(error);
      }
    };
    checkCondition();
  });
}
function pause(time) {
  return new Promise((res) => {
    setTimeout(() => {
      res(true);
    }, time);
  });
}
const convertMSToDateString = (miliseconds, locale = "en-US", options = {}) => {
  if (!miliseconds) {
    console.log("Invalid input");
    return miliseconds;
  }
  return `${new Date(
    typeof miliseconds === "string" ? parseInt(miliseconds, 10) : miliseconds
  ).toLocaleString(locale, options)}`;
};
const createDebounce = (fn, timeMS = 100) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      fn(...args);
    }, timeMS);
  };
};
export {
  StringEnumObjectDto,
  compareItem,
  compareItems,
  convertEnumToDisplayText,
  convertMSToDateString,
  createDebounce,
  delay,
  getStringIdentifier,
  isBrowser,
  parseAsCurrency,
  parseNumber,
  pause,
  randomUUID,
  setSignificantDigits,
  waitForCondition
};
